import React, { useMemo } from 'react';
import classnames from 'classnames';
import Ripple from '../utils/Ripple';
import Icon from '../utils/Icon';
import Modal from '../utils/Modal';
import useHelpNote from '../utils/Translations/useHelpNote';
import style from './ModalWidget.scss';
const ModalWidget = ({ icon, onModalToggle, visible, title = 'Modal Widget', top = false, children, }) => {
    const getHelpNoteTooltipTitle = useHelpNote();
    const resolvedTooltipTitle = useMemo(() => getHelpNoteTooltipTitle(title || ''), [getHelpNoteTooltipTitle, title]);
    return (<li className={classnames(style.noDots)} title={resolvedTooltipTitle}>
      <Ripple>
        <a className={classnames('dropdown-toggle legitRipple', {
        [style.top]: top,
    })} data-toggle="dropdown" href="#" onClick={onModalToggle}>
          <Icon name={icon}/>
        </a>
      </Ripple>

      <Modal size="lg" title={title} visible={visible} onClose={onModalToggle}>
        {children}
      </Modal>
    </li>);
};
export default ModalWidget;
